module.exports = __webpack_public_path__ + "img/robot.c5df8734.png";